<template>
    <b-container fluid class="px-md-5">
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">Mis Clientes</h4>
        <b-row class="justify-content-center">
            <b-col cols="12" md="3" class="mt-4 mb-2">
                <b-button variant="default" pill block size="sm" @click="clearData" v-b-modal.account>
                    <i class="material-icons mdi mdi-account-plus"></i>&nbsp;
                    <span>Agregar Cliente</span>
                </b-button>
            </b-col>
            <b-col cols="12" md="9" class="mt-4 mb-2">
                <b-form-group class="mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="search" v-model="search" type="search" placeholder="Buscar" class="pad-3-15 btlr-30 bblr-30"></b-form-input>

                        <b-input-group-append>
                            <b-button variant="default" :disabled="!search" @click="search = ''" class="m-0 btlr-0 bblr-0">
                                <i class="material-icons mdi mdi-close"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" class="px-0">
                <b-table
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                    class="my-2 border-bottom"
                    stacked="sm"
                    hover
                    small
                    show-empty
                    no-border-collapse
                    table-variant="light"
                    details-td-class="px-0"
                    empty-filtered-text="No hay clientes que coincidan con la búsqueda"
                    empty-text="No tienes clientes registrados"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="search"
                    :busy="isBusy"
                    @filtered="onFiltered">
                    <template #cell(show_details)="row">
                        <b-button variant="info" size="sm" @click="row.toggleDetails" class="mr-2">
                            <i :class="row.detailsShowing ? 'material-icons rotate180' : 'material-icons'">expand_circle_down</i>
                        </b-button>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-danger my-4">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Actualizando...</strong>
                        </div>
                    </template>

                    <template #row-details="row">
                        <b-card class="rounded-0">
                            <b-row class="justify-content-center mx-0 my-2">
                                <b-col cols="12" md="6" class="text-center text-sm-right">
                                    <b>Nombre:</b><br>{{ row.item.cname }}
                                </b-col>
                                <b-col cols="12" md="6" class="text-center text-sm-left">
                                    <b>Documento:</b><br>{{ row.item.dni }}
                                </b-col>
                                <b-col cols="12" md="6" class="text-center text-sm-right">
                                    <b>Email:</b><br>{{ row.item.email }}
                                </b-col>
                                <b-col cols="12" md="6" class="text-center text-sm-left">
                                    <b>Teléfono:</b><br>{{ row.item.mobile }}
                                </b-col>
                                <b-col cols="12" md="6" class="text-center text-sm-right">
                                    <b>Fecha de Nacimiento:</b><br>{{ new Date((''+row.item.birthday).replace(/ /g,"T")) | moment("DD/MM/YYYY") }}
                                </b-col>
                                <b-col cols="12" md="6" class="text-center text-sm-left">
                                    <b>Profesión:</b><br>{{ row.item.profession }}
                                </b-col>
                                <b-col cols="12" class="text-center">
                                    <b>Dirección:</b><br>{{ row.item.address+' '+row.item.district+', '+row.item.city+' - '+row.item.state+', '+row.item.country_name }}
                                </b-col>
                            </b-row>
                            <b-row class="justify-content-center">
                                <b-col cols="12" md="6" class="text-center text-sm-right mt-3">
                                    <b-button variant="default" class="mr-2" @click="clearData(row.item.id)" v-b-modal.account>
                                        <i class="material-icons">manage_accounts</i>&nbsp;&nbsp;Editar
                                    </b-button>
                                </b-col>
                                <b-col cols="12" md="6" class="text-center text-sm-left mt-3">
                                    <b-button variant="success" class="mr-2" :to="'/partner/account/customers/'+row.item.id+'/receivers'">
                                        <i class="material-icons">people</i>&nbsp;&nbsp;Destinatarios
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-card>
                    </template>
                </b-table>

                <!-- Modal Add/Edit Account -->
                <b-modal
                    id="account"
                    centered
                    no-fade
                    header-class="text-center"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    header-close-variant="light"
                    footer-class="border-0"
                    hide-footer
                    body-class="text-center px-4 my-4"
                    :title="(id > 0 ? 'Editar' : 'Agregar Nuevo') + ' Cliente'"
                    tabindex="-1"
                    role="dialog"
                    size="lg"
                    aria-hidden="true">
                    <b-form id="formAccount" @submit.stop.prevent="id === 0 ? exec() : exec(id)">
                        <b-row class="justify-content-center">
                            <b-col cols="12" md="10" align-self="start">
                                <h6 class="subtitle text-center mt-0">Información Básica</h6>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <b-form-group :label="labels.name+':'">
                                    <b-form-input
                                        name="name"
                                        v-model="form.name"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true|alpha_spaces|min:3|max:20'"
                                        :state="validateState('name')"
                                        :data-vv-as="(labels.name).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="name-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="name-live-feedback">{{
                                            veeErrors.first('name')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.lname+':'">
                                    <b-form-input
                                        name="lname"
                                        v-model="form.lname"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true|alpha_spaces|min:3|max:20'"
                                        :state="validateState('lname')"
                                        :data-vv-as="(labels.lname).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="lname-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="lname-live-feedback">{{
                                            veeErrors.first('lname')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.mname+':'">
                                    <b-form-input
                                        name="mname"
                                        v-model="form.mname"
                                        type="text"
                                        class="text-center"
                                        v-validate="'alpha_spaces|max:19'"
                                        :state="validateState('mname')"
                                        :data-vv-as="(labels.mname).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="mname-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="mname-live-feedback">{{
                                            veeErrors.first('mname')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.email+':'">
                                    <b-form-input
                                        name="email"
                                        v-model="form.email"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true'"
                                        :state="validateState('email')"
                                        :data-vv-as="(labels.email).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="email-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="email-live-feedback">{{
                                            veeErrors.first('email')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.mobile+':'">
                                    <b-form-input
                                        name="mobile"
                                        v-model="form.mobile"
                                        type="text"
                                        inputmode="numeric"
                                        class="text-center"
                                        v-validate="'required:true|numeric'"
                                        :state="validateState('mobile')"
                                        :data-vv-as="(labels.mobile).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="mobile-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="mobile-live-feedback">{{
                                            veeErrors.first('mobile')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.birthday+':'">
                                    <b-form-datepicker
                                        name="birthday"
                                        v-model="form.birthday"
                                        v-bind="labels['es'] || {}"
                                        v-validate="'required:true|date_format:yyyy-MM-dd'"
                                        :state="validateState('birthday')"
                                        :data-vv-as="(labels.birthday).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="birthday-live-feedback"
                                        locale="es"
                                        :min="minDate"
                                        :max="maxDate"
                                        hide-header
                                        no-flip
                                        class="text-left"
                                    ></b-form-datepicker>
                                    <b-form-invalid-feedback id="birthday-live-feedback">{{ veeErrors.first('birthday') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.profession+':'">
                                    <b-form-select
                                        name="profession"
                                        :options="professions"
                                        :value="form.profession"
                                        v-model="form.profession"
                                        v-validate="'required:true'"
                                        :state="validateState('profession')"
                                        :data-vv-as="(labels.profession).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="profession-live-feedback"
                                        class="form-control"
                                        value-field="name"
                                        text-field="name"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="profession-live-feedback">{{ veeErrors.first('profession') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <b-form-group :label="labels.pep+':'">
                                    <b-form-select
                                        name="pep"
                                        :options="yes_no"
                                        :value="form.pep"
                                        v-model="form.pep"
                                        v-validate="'required:true'"
                                        :state="validateState('pep')"
                                        :data-vv-as="(labels.pep).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="pep-live-feedback"
                                        class="form-control"
                                        value-field="code"
                                        text-field="text"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="pep-live-feedback">{{ veeErrors.first('pep') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <hr>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <h6 class="subtitle text-center mt-0">Identificación Personal</h6>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.td+':'">
                                    <b-form-select
                                        name="td"
                                        :options="td"
                                        :value="form.td"
                                        v-model="form.td"
                                        class="form-control"
                                        v-validate="'required:true'"
                                        :state="validateState('td')"
                                        :data-vv-as="(labels.td).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="td-live-feedback"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="td-live-feedback">{{
                                            veeErrors.first('td')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start" v-if="form.td === 'RUT'">
                                <b-form-group :label="labels.rut+':'">
                                    <b-form-input
                                        name="rut"
                                        v-model="form.rut"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true'"
                                        :state="validateState('rut')"
                                        :data-vv-as="(labels.rut).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="rut-live-feedback"
                                        v-mask="mask"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="rut-live-feedback">{{ veeErrors.first('rut') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start" v-else>
                                <b-form-group :label="labels.nd+':'">
                                    <b-form-input
                                        name="nd"
                                        v-model="form.nd"
                                        :type="form.td === 'PS' ? 'text' : 'number'"
                                        :inputmode="form.td === 'PS' ? 'text' : 'numeric'"
                                        class="text-center"
                                        v-validate="'required:true'"
                                        :state="validateState('nd')"
                                        :data-vv-as="(labels.nd).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="nd-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="nd-live-feedback">{{
                                            veeErrors.first('nd')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.issuedBy+':'">
                                    <b-form-select
                                        name="issuedBy"
                                        :options="countries_list"
                                        :value="form.issuedBy"
                                        v-model="form.issuedBy"
                                        v-validate="'required:true'"
                                        :state="validateState('issuedBy')"
                                        :data-vv-as="(labels.issuedBy).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="issuedBy-live-feedback"
                                        class="form-control"
                                        value-field="iso2"
                                        text-field="name"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="issuedBy-live-feedback">{{ veeErrors.first('issuedBy') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.expiration+':'">
                                    <b-form-datepicker
                                        name="expiration"
                                        v-model="form.expiration"
                                        v-bind="labels['es'] || {}"
                                        v-validate="'required:true|date_format:yyyy-MM-dd'"
                                        :state="validateState('expiration')"
                                        :data-vv-as="(labels.expiration).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="expiration-live-feedback"
                                        locale="es"
                                        :min="minDateExp"
                                        hide-header
                                        no-flip
                                        class="text-left"
                                    ></b-form-datepicker>
                                    <b-form-invalid-feedback id="expiration-live-feedback">{{ veeErrors.first('expiration') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <hr>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <h6 class="subtitle text-center mt-0">Ubicación Actual</h6>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.address+':'">
                                    <b-form-input
                                        name="address"
                                        v-model="form.address"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true|min:3|max:70'"
                                        :state="validateState('address')"
                                        :data-vv-as="(labels.address).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="address-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="address-live-feedback">{{
                                            veeErrors.first('address')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.district+':'">
                                    <b-form-input
                                        name="district"
                                        v-model="form.district"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true|min:3|max:35'"
                                        :state="validateState('district')"
                                        :data-vv-as="(labels.district).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="district-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="district-live-feedback">{{
                                            veeErrors.first('district')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.zipcode+':'">
                                    <b-form-input
                                        name="zipcode"
                                        v-model="form.zipcode"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true|min:4|max:8'"
                                        :state="validateState('zipcode')"
                                        :data-vv-as="(labels.zipcode).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="zipcode-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="zipcode-live-feedback">{{ veeErrors.first('zipcode') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.city+':'">
                                    <b-form-input
                                        name="city"
                                        v-model="form.city"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true|alpha_spaces|min:3|max:35'"
                                        :state="validateState('city')"
                                        :data-vv-as="(labels.city).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="city-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="city-live-feedback">{{
                                            veeErrors.first('city')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.state+':'">
                                    <b-form-input
                                        name="state"
                                        v-model="form.state"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true|alpha_spaces|min:3|max:35'"
                                        :state="validateState('state')"
                                        :data-vv-as="(labels.state).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="state-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="state-live-feedback">{{
                                            veeErrors.first('state')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start" class="my-4">
                                <b-button type="submit" variant="default" size="lg" pill class="shadow align-middle px-5"
                                          form="formAccount" :disabled="loading">
                                    <b-spinner small type="grow" v-if="loading"></b-spinner>
                                    <b-icon icon="upload" aria-hidden="true" class="align-middle" v-else></b-icon>
                                    &nbsp;&nbsp;<span>{{ loading ? (id === 0 ? 'Guardando...' : 'Actualizando...') : (id === 0 ? 'Guardar' : 'Actualizar' ) }}</span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-modal>
            </b-col>
            <b-col sm="5" md="6">
                <b-form-group
                    label="Mostrar:"
                    label-for="per-page-select"
                    label-cols-sm="4"
                    label-cols-md="6"
                    label-cols-lg="9"
                    label-align-sm="right"
                    label-size="sm"
                    class="mt-2 mb-8">
                    <b-form-select
                        id="per-page-select"
                        v-model="perPage"
                        :options="pageOptions"
                        size="sm"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="mt-2 mb-8"
                ></b-pagination>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from "axios";

export default {
    name: "PartnerCustomers",
    props: [ 'user' ],
    data: () => ({
        id: 0,
        labels: {
            name: 'Nombres',
            lname: 'Primer Apellido',
            mname: 'Segundo Apellido',
            rut: 'RUT',
            td: 'Tipo de Documento',
            nd: 'Número de Documento',
            issuedBy: 'País de emisión',
            expiration: 'Fecha de Vencimiento',
            noExp: 'Sin Fecha de Vencimiento',
            email: 'Correo Electrónico',
            mobile: 'Teléfono',
            birthday: 'Fecha de Nacimiento',
            profession: 'Profesión',
            pep: '¿Eres Persona Expuesta Políticamente?',

            address: 'Dirección',
            district: 'Barrio/Comuna',
            zipcode: 'Código Postal',
            city: 'Ciudad',
            state: 'Estado',
            country: 'País',

            es: {
                labelPrevDecade: 'Década Anterior',
                labelPrevYear: 'Año Anterior',
                labelPrevMonth: 'Mes Anterior',
                labelCurrentMonth: 'Mes Actual',
                labelNextMonth: 'Próximo Mes',
                labelNextYear: 'Próximo Año',
                labelNextDecade: 'Próxima Década',
                labelToday: 'Hoy',
                labelSelected: 'Fecha Seleccionada',
                labelNoDateSelected: 'Sin fecha seleccionada',
                labelCalendar: 'Calendario',
                labelNav: 'Navegar por el calendario',
                labelHelp: 'Use las teclas de flecha para navegar por el calendario'
            }
        },
        form: {
            name: null,
            lname: null,
            mname: null,
            td: null,
            nd: null,
            rut: null,
            issuedBy: '',
            expiration: undefined,
            email: null,
            mobile: null,
            birthday: null,
            profession: null,
            pep: 0,

            address: null,
            district: null,
            zipcode: '',
            city: null,
            state: null,
            country: 'CL',
            country_name: 'Chile'
        },
        countries: [
            { text: 'Chile', value: 'CL' }
        ],
        td: [
            { value: 'RUT', text: 'RUT' },
            { value: 'DNI', text: 'Documento Nacional de Identidad' },
            { value: 'CI', text: 'Cedula de Identidad' },
            { value: 'CE', text: 'Cedula de Extranjeria' },
            { value: 'PS', text: 'Pasaporte' }
        ],
        professions: [
            { name: 'Ingeniero/a' },
            { name: 'Estudiante' },
            { name: 'Comerciante' },
            { name: 'Empresario/a' },
            { name: 'Abogado/a' },
            { name: 'Administrador/a' },
            { name: 'Médico/a' },
            { name: 'Arquitecto/a' },
            { name: 'Economista' },
            { name: 'Profesor/a' },
            { name: 'Programador/a' },
            { name: 'Amo/a de Casa' },
            { name: 'Artísta ó Artesano/a' },
            { name: 'Rentista de Capital' },
            { name: 'Policía ó Militar' },
            { name: 'Agricultor/a, Ganadero/a ó Pescador/a' },
            { name: 'Técnico/a' },
            { name: 'Otra' }
        ],
        yes_no: [
            { code: 0, text: 'No' },
            { code: 1, text: 'Si' }
        ],
        countries_list: [],
        minDateExp: undefined,
        minDate: undefined,
        maxDate: undefined,
        loading: false,
        isBusy: true,
        search: '',
        fields: [
            { key: 'cname', label: 'Nombre', sortable: true },
            { key: 'dni', label: 'Documento', sortable: true },
            { key: 'email', label: 'Correo Electrónico', sortable: true },
            { key: 'mobile', label: 'Teléfono', sortable: true },
            { key: 'country_name', label: 'País', sortable: true },
            { key: 'show_details', label: 'Acción', sortable: false }
        ],
        items: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 25,
        pageOptions: [25, 50, 100, { value: -1, text: "Todos" }],
        mask: '##.###.###-N'
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'customerspage');
        this.getData();
        this.getDate();
    },
    watch: {
        'user.partner'() {
            clearTimeout(this.timeout);
            this.getData();
        },
        'form.td'() {
            if (this.form.td === 'RUT') {
                this.form.nd = null;
            } else {
                this.form.rut = null;
            }
        },
        'form.nd'() {
            if (this.form.nd) {
                this.form.nd = (this.form.nd).toUpperCase();
            }
        },
        'form.rut'() {
            if (this.form.rut) {
                this.form.rut = (this.form.rut).toUpperCase();
                if (this.form.td === 'RUT') {
                    this.form.nd = this.form.rut;
                }
            }
        }
    },
    methods: {
        getData() {
            axios.get('/api/partner/senders').then((res) => {
                if (res.data.status === 'success') {
                    this.items = res.data.senders;
                    this.countries_list = res.data.countries;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.totalRows = this.items.length;
                this.isBusy = false;
            });
            this.timeout = setTimeout(this.getData, 180000);
        },
        getDate() {
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            // 100 años menos
            const minDate = new Date(today)
            minDate.setFullYear(minDate.getFullYear() - 100)
            // 18 años menos
            const maxDate = new Date(today)
            maxDate.setFullYear(maxDate.getFullYear() - 18)

            this.minDate = minDate;
            this.maxDate = maxDate;
            this.minDateExp = today;
        },
        clearData(id) {
            this.form = {
                name: null,
                lname: null,
                mname: null,
                td: null,
                nd: null,
                rut: null,
                issuedBy: null,
                expiration: undefined,
                email: null,
                mobile: null,
                birthday: null,
                profession: null,
                pep: 0,

                address: null,
                district: null,
                zipcode: null,
                city: null,
                state: null,
                country: 'CL',
                country_name: 'Chile'
            };
            if (id) {
                this.id = id;
                const items = this.items;

                for (let i = 0; i < items.length; i++) {
                    if (items[i].id === id) {
                        let lname = (items[i].lname).split(', ', 2);
                        this.form = items[i];
                        this.form.lname = lname[0];
                        this.form.mname = lname[1] ? lname[1] : '';
                        if (items[i].td === 'RUT') {
                            this.form.rut = items[i].nd;
                            this.form.nd = null;
                        } else {
                            this.form.rut = null;
                        }
                    }
                }
            } else {
                this.id = 0;
            }
        },
        exec(id) {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.loading = true;
                let url = '/api/partner/senders';
                if (id) {
                    url += '/' + id + '/edit';
                } else {
                    url += '/add';
                }
                axios.post(url, this.form).then((res) => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    if (res.data.status === 'success') {
                        this.getData();
                        this.$bvModal.hide('account');
                        this.clearData();
                        this.$validator.reset();
                    }
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.loading = false;
                });
            });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetValidationState() {
            this.isValid = undefined
        }
    },
    destroyed() {
        clearTimeout(this.timeout);
    }
}
</script>

<style scoped>

</style>
